import { render } from "./DashboardEmitent.vue?vue&type=template&id=22738c97&scoped=true"
import script from "./DashboardEmitent.vue?vue&type=script&lang=js"
export * from "./DashboardEmitent.vue?vue&type=script&lang=js"

import "./DashboardEmitent.vue?vue&type=style&index=0&id=22738c97&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22738c97"]])

export default __exports__